<template>
    <HospitalListItem v-for="hospital in hospitalList"
                      :key="hospital.id"
                      :hospital="hospital"
                      :member="member"
                      @displayHospitalModal="displayHospitalModal"/>


    <v-btn v-if="member.role === HpoRole.ZOS"
           variant="outlined"
           size="x-large"
           @click="displayHospitalModal({})"
           class="pa-2 h-auto"
    >
        <div>
            <p style="width: min-content; white-space: break-spaces">{{ gettext('Add hospital') }}</p>
            <v-icon :icon="mdiPlusCircleOutline" site="x-large" class="mt-2"></v-icon>
        </div>
    </v-btn>

    <HospitalModal v-if="editedHospital"
                   :hpoId="hpoId"
                   :hospital="editedHospital"
                   @close="hideHospitalModal"/>
</template>

<script setup>
import HospitalModal from "@/components/hpo/dashboard/hospital/HospitalModal";
import {ref} from "vue";
import HospitalListItem from "@/components/hpo/dashboard/hospital/HospitalListItem";
import {HpoRole} from "../../choices";
import {mdiPlusCircleOutline} from "@mdi/js";

const props = defineProps({
    hpoId: {
        type: String,
        required: true,
    },
    hospitalList: {
        type: Array,
        required: false,
        default: []
    },
    member: {
        type: Object,
        required: true
    },
})

const editedHospital = ref(null)


function displayHospitalModal(hospital) {
    editedHospital.value = hospital
}

function hideHospitalModal() {
    editedHospital.value = null
}
</script>
